import { locales } from "configs/i18n";
import i18next from "i18next";

i18next.addResources(locales.EN, "FORGOT_PASSWORD_VIEW", {
  TITLE: "Forgot password",
  ERROR: "An error occurred",
  SUCCEED: "Check your email inbox",
});
